var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2041(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 29,
    viewBox: "0 0 126 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_511)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12_511)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_12_511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8853 0.581483C22.556 0.824768 28.5926 7.25993 28.3537 14.9321C28.1104 22.6043 21.6766 28.642 14.0059 28.4031C6.33144 28.1598 0.294542 21.7346 0.537607 14.0624C0.7728 6.50989 7.0046 0.538278 14.5198 0.581483C14.6391 0.582115 14.7655 0.577751 14.8853 0.581483ZM43.3201 8.27762C47.2396 8.27762 50.2637 10.8702 50.7213 14.6303H46.7422C46.4437 12.8492 45.1107 11.6222 43.3599 11.6222C41.2509 11.6222 39.9179 13.245 39.9179 15.6594C39.9179 18.0936 41.2509 19.7362 43.3599 19.7362C45.0908 19.7362 46.4238 18.5092 46.7422 16.7083H50.7213C50.2438 20.5081 47.2396 23.0808 43.3201 23.0808C39.2614 23.0808 36.0582 19.8352 36.0582 15.6594C36.0582 11.5034 39.2614 8.27762 43.3201 8.27762ZM76.7449 8.57447C79.8685 8.57447 81.8183 9.94001 81.8183 12.4138C81.8183 13.6606 81.1617 14.6303 79.968 15.3428C81.4204 15.9563 82.2361 17.0052 82.2361 18.5092C82.2361 21.1809 80.2465 22.784 76.9239 22.784H71.0149V8.57447H76.7449ZM91.5473 8.57447L96.7799 22.784H92.7211L91.8457 20.1518H86.832L85.9367 22.784H82.1366L87.4289 8.57447H91.5473ZM101.833 8.57447L107.106 16.7875V8.57447H110.548V22.784H106.927L101.236 13.9179V22.784H97.7945V8.57447H101.833ZM116.596 8.57447V14.5512L121.053 8.57447H125.33L120.297 15.2438L125.469 22.784H120.893L116.596 16.3719V22.784H112.836V8.57447H116.596ZM54.1832 8.57447L56.113 17.0447L58.3811 8.57447H62.1812L64.3696 17.0831L66.3195 8.57447H70.0002L66.3593 22.784H62.5791L60.2513 13.9377L57.9235 22.784H54.1235L50.5025 8.57447H54.1832ZM14.5393 1.90653C7.71521 1.86624 2.07577 7.30443 1.86222 14.2121C1.76135 17.4173 2.84735 20.3729 4.71877 22.6673L23.0596 5.31042C20.9044 3.28506 18.0451 2.00825 14.8643 1.90653C14.7554 1.90323 14.6476 1.90717 14.5393 1.90653ZM76.6255 16.926H74.4171V19.8352H76.6255C78.0381 19.8352 78.6947 19.2811 78.6947 18.3707C78.6947 17.4999 78.0381 16.926 76.6255 16.926ZM89.3786 12.6909L87.8467 17.2031H90.8708L89.3786 12.6909ZM76.4464 11.5232H74.4171V13.9772H76.4464C77.6999 13.9772 78.2768 13.5023 78.2768 12.7304C78.2768 11.9982 77.6999 11.5232 76.4464 11.5232Z",
    fill: "white",
    fillOpacity: 0.5
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 27.83,
    fill: "white",
    transform: "translate(0.5 0.579956)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12_511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 27.83,
    fill: "white",
    transform: "translate(0.5 0.579956)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_12_511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124.939,
    height: 27.83,
    fill: "white",
    transform: "translate(0.530518 0.579956)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2041);
export default __webpack_public_path__ + "static/media/2041.dfc72dfa57e2dd852775ed99ae959f1b.svg";
export { ForwardRef as ReactComponent };